import isWithinInterval from 'date-fns/isWithinInterval'
import parseISO from 'date-fns/parseISO'
import addDays from 'date-fns/addDays'
import Vue from 'vue'

export default {
  SET_PRODUCT: (state, { product }) => {
    console.log('Setting product in cache:', product.slug)
    Vue.set(state.productsCache, product.slug, product)
  },
  SET_USERDATA(state, data) {
    state.user.authenticated = true
    if (data.is_admin) {
      state.user.is_admin = true
    } else {
      state.user.is_admin = false
    }
    if (data.firstname) {
      state.user.firstname = data.firstname
      localStorage.setItem('firstname', data.firstname)
    }
    if (data.lastname) {
      state.user.lastname = data.lastname
      localStorage.setItem('lastname', data.lastname)
    }
    if (data.email) {
      state.user.email = data.email
      localStorage.setItem('email', data.email)
    }
    if (data.discount) {
      state.user.discount = data.discount
    }
  },
  setCurrentSearch(state, search) {
    state.currentSearch = search
  },
  clearUserData(state) {
    localStorage.removeItem('id_token')
    localStorage.removeItem('firstname')
    localStorage.removeItem('lastname')
    localStorage.removeItem('email')
    localStorage.removeItem('discount')
    state.user = {
      authenticated: false,
      firstname: null,
      lastname: null,
      email: null,
      is_admin: false,
      discount: 0,
    }
  },
  adminUpdateProduct(state, product) {
    const adminProductIndex = state.adminProducts.findIndex(
      (item) => item.id === product.id,
    )
    // console.log(adminProductIndex)
    // console.log(product)
    // console.log(...state.adminProducts.slice(0, adminProductIndex))
    // console.log(...state.adminProducts.slice(adminProductIndex + 1))
    state.adminProducts = [
      ...state.adminProducts.slice(0, adminProductIndex),
      product,
      ...state.adminProducts.slice(adminProductIndex + 1),
    ]
    // toto prerobit nech to respektuje reaktivitu
    // state.adminProducts[state.adminProducts.findIndex(item => item.id === product.id)] = product
  },
  setAdminData(state, data) {
    state.admin.authors = data.authors.map((author) => author.author)
    state.admin.publishers = data.publishers.map(
      (publisher) => publisher.publisher,
    )
    state.categories = data.categories
  },
  setCategories(state, categories) {
    state.categories = categories
  },
  setCategoriesTree(state, categoriesTree) {
    state.categoriesTree = categoriesTree
  },
  emptyProducts(state) {
    state.products = []
  },
  setSearchResult(state, searchResult) {
    state.searchResult = searchResult
  },
  setCountries(state, data) {
    state.countries = data
  },
  setBestsellers(state, data) {
    state.bestsellers = data
  },
  setLatestProducts(state, data) {
    state.latestProducts = data
  },
  updateProducts(state, data) {
    const { pagination } = data
    state.products = data.data
    state.totalProducts = pagination.total
    state.pagination.currentPage = pagination.current_page
    state.pagination.lastPage = pagination.last_page
    state.pagination.total = pagination.total
    // state.loadedCategory = data.category
  },
  changePerPage(state, perPage) {
    state.pagination.perPage = perPage
  },
  changeOrderBy(state, orderBy) {
    state.orderBy = orderBy
  },
  changeOrderByDirection(state, direction) {
    state.orderByDirection = direction
  },
  toggleOrderByDirection(state) {
    state.orderByDirection = state.orderByDirection === 'desc' ? 'asc' : 'desc'
  },
  changePage(state, page) {
    state.pagination.currentPage = page
  },
  applyCustomerDiscountOnCart(state) {
    state.cart.forEach((product) => {
      if (!product.usedCustomerDiscount) {
        product.usedItemPrice =
          (product.price * (100 - state.user.discount)) / 100
        product.lineItemPrice = product.usedItemPrice * product.quantity
        product.usedCustomerDiscount = true
      }
    })
  },
  removeCustomerDiscountFromCart(state) {
    const now = Date.now()
    state.cart.forEach((product) => {
      if (product.usedCustomerDiscount) {
        delete product.usedCustomerDiscount
        if (
          product.discountPrice &&
          isWithinInterval(now, {
            start: parseISO(product.discountPriceActiveFrom),
            end: addDays(parseISO(product.discountPriceActiveUntil), 1),
          })
        ) {
          product.usedItemPrice = product.discountPrice
        } else {
          product.usedItemPrice = product.price
        }
        product.lineItemPrice = product.usedItemPrice * product.quantity
      }
    })
  },
  addToCart(state, product) {
    if (!state.cart.find((cartItem) => cartItem.id === product.id)) {
      product.quantity = 1
      product.lineItemPrice = product.usedItemPrice
      state.cart.push(product)
    } else {
      const productInCart = state.cart.find(
        (cartItem) => cartItem.id === product.id,
      )
      productInCart.quantity += 1
      productInCart.lineItemPrice += productInCart.usedItemPrice
    }
    // sem pridat ulozenie kosika do localstorage
    localStorage.setItem('cart', JSON.stringify(state.cart))
  },
  removeFromCart(state, product) {
    const productInCartIndex = state.cart.findIndex(
      (cartItem) => cartItem.id === product.id,
    )
    state.cart.splice(productInCartIndex, 1)
    localStorage.setItem('cart', JSON.stringify(state.cart))
  },
  increaseInCart(state, product) {
    const productInCart = state.cart.find(
      (cartItem) => cartItem.id === product.id,
    )
    productInCart.lineItemPrice += product.usedItemPrice
    productInCart.quantity += 1
    localStorage.setItem('cart', JSON.stringify(state.cart))
  },
  decreaseInCart(state, product) {
    const productInCart = state.cart.find(
      (cartItem) => cartItem.id === product.id,
    )
    if (productInCart.quantity > 1) {
      productInCart.lineItemPrice -= product.usedItemPrice
      productInCart.quantity -= 1
    } else {
      // remove from cart
      const cartItem = state.cart.find((item) => item.id === product.id)
      state.cart.splice(state.cart.indexOf(cartItem), 1)
    }
    localStorage.setItem('cart', JSON.stringify(state.cart))
  },
  setCart(state, cart) {
    state.cart = cart
    localStorage.setItem('cart', JSON.stringify(state.cart))
  },
  setAddressbook(state, addressbook) {
    if (Object.getOwnPropertyNames(addressbook).length > 1) {
      state.addressbook = addressbook
    } else {
      state.addressbook = {
        billing_addressee: '',
        billing_street: '',
        billing_city: '',
        billing_postcode: '',
        billing_country_id: 198,
        billing_phone: '',
        billing_ICO: '',
        billing_DIC: '',
        billing_ICDPH: '',
        billing_email: '',
        shipping_addressee: '',
        shipping_company: '',
        shipping_street: '',
        shipping_city: '',
        shipping_postcode: '',
        shipping_country_id: 198,
        shipping_phone: '',
      }
      if (state.user.firstname && state.user.lastname) {
        state.addressbook.billing_addressee = `${state.user.firstname} ${state.user.lastname}`
      }
      if (state.user.email) {
        state.addressbook.billing_email = state.user.email
      }
    }
  },
  setAuthenticated(state, authenticated) {
    state.user.authenticated = authenticated
  },
  setCheckingAuth(state, status) {
    state.checkingAuth = status
  },
  setCartScreen(state, screen) {
    state.cartScreen = screen
  },
  setAdminProducts(state, products) {
    state.adminProducts = products
  },
  updateAdminProductsPagination(state, pagination) {
    state.adminProductsPagination.currentPage = pagination.currentPage
    state.adminProductsPagination.lastPage = pagination.lastPage
    state.adminProductsPagination.perPage = pagination.perPage
    state.adminProductsPagination.total = pagination.total
  },
}
